module.exports = __webpack_public_path__ + "static/media/ic_hs_b5_fisdom.da44bcbd.svg";